import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import VetSupportHub from "@/pages/VetSupportHub";
import Solutions from "@/pages/Solutions";
import Products from "@/pages/Products";
import Instruments from "@/pages/Instruments";
import ColdChain from "@/pages/ColdChain";
import Training from "@/pages/Training";
import Stockist from "@/pages/Stockist";
import Distribution from "@/pages/Distribution";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // wait a frame for layout
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vet-support-hub" element={<VetSupportHub />} />
          <Route path="/vet-professionals" element={<VetSupportHub />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/products" element={<Products />} />
          <Route path="/instruments" element={<Instruments />} />
          <Route path="/cold-chain" element={<ColdChain />} />
          <Route path="/training" element={<Training />} />
          <Route path="/become-a-stockist" element={<Stockist />} />
          <Route path="/distribution" element={<Distribution />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
